import React, {Component} from 'react';

export class AppFooter extends Component {

	render() {
		return null
	}
}